export default {"src":"/spot-fe-premarket/_next/static/media/3.d44fbb9d.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};